import { setDataLayer } from "../../defaults/gtm";
import { pushToMixPanel } from "../../defaults/mixPanel";

export const useEventsTrack = (prefix) => {
  const prefixDefault = `${process.env.NX_PUBLIC_PRODUCT_NAME || 'EVENT'}_`;

  const eventPrefix = prefix || prefixDefault;

  const sendEventSegment = async (event, data, type) => {
    const eventName = `${eventPrefix}${event}`;
    await window.analytics[type](eventName, data);
  };

  const sendEventGTM = (event, data, dataLayerName) => {
    const eventName = `${eventPrefix}${event}`;
    setDataLayer({ event: eventName, ...data }, dataLayerName);
  };

  const sendEventMixPanel = (event, data) => {
    const eventName = `${eventPrefix.toLowerCase()}_${event.replaceAll(/([a-z])([A-Z])/g, '$1_$2').toLowerCase()}`;
    pushToMixPanel({ event: eventName, ...data });
  };

  const trackGTM = (event, data = {}, dataLayerName = 'dataLayer') => sendEventGTM(event, data, dataLayerName);
  const trackMixPanel = (event, data = {}) => sendEventMixPanel(event, data);
  const trackSegment = async (event, data = {}) => await sendEventSegment(event, data, 'track');
  const trackPageSegment = async (event, data = {}) => await sendEventSegment(event, data, 'page');
  const trackIdentify = (identify) => window.analytics.identify(identify);

  return {
    trackSegment,
    trackGTM,
    trackPageSegment,
    trackIdentify,
    trackMixPanel,
  };
};
